export class CountBySubCategoryGroupDetails{
    date: string;
    subCategoryName:string;
    tdyActualRevenue:string;
    uom:string;
}